import { render, staticRenderFns } from "./createExportFooter.vue?vue&type=template&id=93f2c6d4"
import script from "./createExportFooter.vue?vue&type=script&lang=js"
export * from "./createExportFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports